import { Injectable } from '@nestjs/common';
import { Repository, Raw, getConnection } from 'typeorm';
import { GradesDTO } from '../grades/dto/grades.dto';
import { Grades} from '../grades/grades.entity';
import { GradesAdapter } from '../grades/dto/grades.adapter';
import { GradesResponseModel, AllGradesResponseModel } from '@gtpl/shared-models/masters';
import { InjectRepository } from '@nestjs/typeorm';
import { ErrorResponse, UserRequestDto } from '@gtpl/shared-models/common-models';
import { GradeRequest } from './dto/grades.request';
import { LogsService } from '@gtpl/shared-services/user-logs';
import { LogsDto } from 'libs/shared-models/user-logs/src/lib/Logs/logs.dto';

@Injectable()
export class GradesService {

    constructor(
      private logService:LogsService,

        @InjectRepository(Grades)
        private gradesRepository: Repository<Grades>,
        private gradesAdapter: GradesAdapter,
    ){}

    async getGradeDetailsWithoutRelations(gradeName: string): Promise<Grades> {
        // tslint:disable-next-line: typedef
        const gradesResponse = await this.gradesRepository.findOne({
          where: {gradeName: Raw(alias => `grade_name = '${gradeName}'`)},
        });
        if (gradesResponse) {
          return gradesResponse;
        } else {
          return null;
        }
      }

      async createGrade(gradesDto: GradesDTO, isUpdate: boolean): Promise<GradesResponseModel> {
        // console.log(statesDto);
        try {
          let previousValue
          // to check whether State exists with the passed  State code or not. if isUpdate is false, a check will be done whether a record with the passed Statecode is existing or not. if a record exists then a return message wil be send with out saving the data.  if record is not existing with the passed State code then a new record will be created. if isUpdate is true, then no check will be performed and  record will be updated(if record exists with the passed cluster code) or created.
          if (!isUpdate) {
            const gradesEntity = await this.getGradeDetailsWithoutRelations(gradesDto.gradeName);
            if (gradesEntity) {
              //return new InformationMessageError(11104, "State already exists");
              throw new GradesResponseModel(false,11104, 'Grade already exists');
            }
          }else{
            const previous = await this.gradesRepository.findOne({where:{gradeId:gradesDto.gradeId}})
            previousValue = previous.gradeName
        }
          const convertedGradeEntity: Grades = this.gradesAdapter.convertDtoToEntity(gradesDto,isUpdate);
          const savedGradeEntity: Grades = await this.gradesRepository.save(
            convertedGradeEntity
          );
          const savedGradeDto: GradesDTO = this.gradesAdapter.convertEntityToDto(convertedGradeEntity);
            // console.log(savedStateDto);
          if (savedGradeDto) {
            // generating resposnse
            const certificatePresent = savedGradeDto.gradeName;
        const response = new GradesResponseModel(true,1,isUpdate? 'Grade Updated Successfully': 'Grade Created Successfully',savedGradeDto);
        const name=isUpdate?'updated':'created'
        const displayValue = isUpdate? 'Grade Updated Successfully': 'Grade Created Successfully'
            const userName = isUpdate? savedGradeDto.updatedUser :savedGradeDto.createdUser;
            const newLogDto = new LogsDto(1,name, 'Grades', savedGradeDto.gradeId, true, displayValue,userName,previousValue,certificatePresent)
            let res = await this.logService.createLog(newLogDto);
            console.log(res);
        return response;

          } else {
            //return new InformationMessageError(11106, "State saved but issue while transforming into DTO");
            throw new GradesResponseModel(false,11106,'Grade saved but issue while transforming into DTO');
          }
        } catch (error) {
          // when error occures while saving the data , the execution will come to catch block.
          // tslint:disable-next-line: typedef
          return error;
        }
      }  

      async getAllGrades(req?:UserRequestDto): Promise<AllGradesResponseModel> {
        // const page: number = 1;
        try {
          const gradesDtos: GradesDTO[] = [];
          //retrieves all companies
          const gradesEntities: Grades[] = await this.gradesRepository.createQueryBuilder("grades")
          // .where("is_active=1")
          .orderBy(`CASE WHEN grade_name REGEXP '^[0-9]' THEN 0 ELSE 1 END`)
          .addOrderBy('CAST(grade_min_count AS UNSIGNED)','ASC')
          .addOrderBy('CASt(grade_max_count AS UNSIGNED)','ASC')
          .groupBy('grade_name')
          .getMany();
          //console.log(statesEntities);
          if (gradesEntities) {
            // conver,ts the data fetched from the database which of type companies array to type StateDto array.
            gradesEntities.forEach(GradeEntity => {
              const convertedgradesDto: GradesDTO = this.gradesAdapter.convertEntityToDto(
                GradeEntity
              );
              gradesDtos.push(convertedgradesDto);
            });
    // console.log(gradesDtos);
            //generated response
        const response = new AllGradesResponseModel(true,1,'Grades retrieved successfully',gradesDtos);
        if(req?.createdUser){
          const newLogDto = new LogsDto(1,'view', 'Grades', 0, true, 'Grades retrieved successfully',req.createdUser)
          let res = await this.logService.createLog(newLogDto);
          console.log("****************");
          console.log(res);
        }
     

        return response;
         
          } else {
            throw new GradesResponseModel(false,99998, 'Data not found');
          }
         
        } catch (err) {
          throw err;
        }
      }


      async getAllActiveGrades(): Promise<AllGradesResponseModel> {
        // const page: number = 1;
        try {
            const gradesDtos: GradesDTO[] = [];
            //retrieves all companies
            const GradesEntities: Grades[] = await this.gradesRepository.find({ order: { 'gradeName': 'ASC' },
           });
         console.log(GradesEntities)
            if (GradesEntities) {
                // converts the data fetched from the database which of type companies array to type StateDto array.
                GradesEntities.forEach(GradeEntity => {
                    const convertedgradesDto: GradesDTO = this.gradesAdapter.convertEntityToDto(
                      GradeEntity
                    );
                    gradesDtos.push(convertedgradesDto);
                });
                const response = new AllGradesResponseModel(true, 11108, "Grades retrieved successfully", gradesDtos);
                return response;
            } else {
                throw new GradesResponseModel(false,99998, 'Data not found'); gradesDtos
            }
        } catch (err) {
            throw err;
        }
    }

      async activateOrDeactivateGrade(gradeReq: GradeRequest): Promise<GradesResponseModel> {
        try {
            const gradeExists = await this.getGradeById(gradeReq.gradeId);
            if (gradeExists) {
                if (gradeReq.versionFlag !== gradeExists.versionFlag) {
                    throw new GradesResponseModel(false,10113, 'Someone updated the current grade information.Refresh and try again');
                } else {
                    
                        const gradeStatus =  await this.gradesRepository.update(
                            { gradeId: gradeReq.gradeId },
                            { isActive: gradeReq.isActive,updatedUser: gradeReq.updatedUser });
                       
                        if (gradeExists.isActive) {
                            if (gradeStatus.affected) {
                                const gradeResponse: GradesResponseModel = new GradesResponseModel(true, 10115, 'Grades is de-activated successfully');
                                return gradeResponse;
                            } else {
                                throw new GradesResponseModel(false,10111, 'grade is already deactivated');
                            }
                        } else {
                            if (gradeStatus.affected) {
                                const gradeResponse: GradesResponseModel = new GradesResponseModel(true, 10114, 'grade is activated successfully');
                                return gradeResponse;
                            } else {
                                throw new GradesResponseModel(false,10112, 'grade is already  activated');
                            }
                        }
                    // }
                }
            } else {
                throw new GradesResponseModel(false,99998, 'No Records Found');
            }
        } catch (err) {
            throw err;
        }
      }
      async getActiveGradeById(gradeReq: GradeRequest): Promise<GradesResponseModel> {
        try {
            //retrieves all companies
            const gradeEntities: Grades = await this.gradesRepository.findOne({
              where:{gradeId:gradeReq.gradeId,isActive:true}
              });
              
              const gradeData: GradesDTO = this.gradesAdapter.convertEntityToDto(gradeEntities);
              if (gradeData) {
                  const response = new GradesResponseModel(true, 11101 , 'Grade retrived Successfully',gradeData);
                  return response;
              }
              else{
                  throw new GradesResponseModel(false,11106,'Something went wrong');
              }
              // generating resposnse
         } catch (err) {
            throw err;
        }
      }
      async getGradeById(gradeId: number): Promise<Grades> {
        //  console.log(employeeId);
            const Response = await this.gradesRepository.findOne({
            where: {gradeId: gradeId},
            });
            // console.log(employeeResponse);
            if (Response) {
            return Response;
            } else {
            return null;
            }
        }
}
